export default __webpack_public_path__ + "static/media/reformas_miniatura.f7567037.jpg";